<template>
    <div>
        <app-overlay-loader v-if="preloader" />
        <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="
                selectedUrl
                    ? `transaction/new-course/${inputs.id}`
                    : `transaction/new-course`
            "
        >
        
            <div class="form-group row align-items-center">
                <label for="inputs_academic_calendar_id" class="col-sm-3 mb-0">
                    Semester
                </label>
                
                <app-input
                    id="inputs_academic_calendar_id"
                    class="col-sm-9"
                    type="advance-search-select"
                    :loaded-per-time="10"
                    v-model="input_academic_calendar_id"
                    @input="setAcademicCalendarId"
                    fetch-url="master/academic-calendar"
                    placeholder="Semester"
                    list-value-field="academic_calendar_name"
                    :required="true"
                />
            </div>
            <div class="form-group row align-items-center">
                <label for="inputs_teaching_type_id" class="col-sm-3 mb-0">
                    Teaching Type
                </label>
                <app-input
                    id="inputs_teaching_type_id"
                    class="col-sm-9"
                    type="search-select"
                    :list="teachingTypeList"
                    @input="setTeachingType"
                    v-model="inputs.teaching_type"
                    placeholder="Teaching Type"
                    :required="true"
                />
            </div>
            <!-- Center ID -->
            <div class="form-group row align-items-center" v-if="showCentre">
                <label for="inputs_center_id" class="col-sm-3 mb-0">
                    Center
                </label>
                <app-input
                    id="inputs_center_id"
                    class="col-sm-9"
                    type="advance-search-select"
                    :loaded-per-time="10"
                    v-model="input_center_id"
                    @input="setCenterId"
                    fetch-url="master/center"
                    placeholder="Center"
                    list-value-field="name"
                    :required="true"
                />
            </div>
            <div class="form-group row align-items-center">
                <label for="inputs_course_name" class="col-sm-3 mb-0">
                    Class Name
                </label>
                <app-input
                    id="inputs_course_name"
                    class="col-sm-9"
                    type="text"
                    v-model="inputs.course_name"
                    :placeholder="'Class Name'"
                    :required="true"
                />
            </div>
    
            <!-- Product -->
            <!-- <div class="form-group row align-items-center">
                <label for="inputs_product_level_id" class="col-sm-3 mb-0">
                    Product Level
                </label>
                <app-input
                    id="inputs_product_level_id"
                    class="col-sm-9"
                    type="advance-search-select"
                    :loaded-per-time="10"
                    v-model="input_product_level_id"
                    @input="setProductLevelId"
                    fetch-url="master/product-level"
                    placeholder="Product Level"
                    list-value-field="product_level_desc"
                    :required="true"
                />
            </div> -->
    
            <!-- SC -->
            
            <div class="form-group row align-items-center">
                <label for="inputs_teacher_id" class="col-sm-3 mb-0">
                    Teacher
                </label>
                
                <app-input
                    id="inputs_teacher_id"
                    class="col-sm-9"
                    type="advance-search-select"
                    :loaded-per-time="10"
                    v-model="input_teacher_id"
                    @input="setTeacherId"
                    fetch-url="user-list?role_name=Teacher"
                    placeholder="Teacher"
                    list-value-field="full_name"
                    :required="true"
                />
            </div>
            <div class="form-group row align-items-center">
                <label for="inputs_side_teacher_id" class="col-sm-3 mb-0">
                    Side Teacher
                </label>
                <app-input
                    id="inputs_side_teacher_id"
                    class="col-sm-9"
                    type="advance-search-select"
                    :loaded-per-time="10"
                    v-model="input_side_teacher_id"
                    @input="setSideTeacherId"
                    fetch-url="user-list?role_name=Teacher"
                    placeholder="Side Teacher"
                    list-value-field="full_name"
                />
            </div>
            <div class="form-group row align-items-center">
                <label for="inputs_trainer_teacher_id" class="col-sm-3 mb-0">
                    Trainer Teacher
                </label>
                
                <app-input
                    id="inputs_trainer_teacher_id"
                    class="col-sm-9"
                    type="advance-search-select"
                    :loaded-per-time="10"
                    v-model="input_trainer_teacher_id"
                    @input="setTrainerTeacherId"
                    fetch-url="user-list?role_name=Teacher"
                    placeholder="Trainer Teacher"
                    list-value-field="full_name"
                />
            </div>
            
    
            <!-- Nomor Urut -->
            <!-- <div class="form-group row align-items-center">
                <label for="inputs_course_serial_number" class="col-sm-3 mb-0">
                    Number List
                </label>
                <app-input
                    id="inputs_course_serial_number"
                    class="col-sm-9"
                    type="text"
                    v-model="inputs.serial_number"
                    :placeholder="'Number List'"
                    :required="true"
                />
            </div> -->
            <!-- Meet -->
            <!-- <div class="form-group row align-items-center">
                <label for="inputs_course_meet" class="col-sm-3 mb-0">
                    Meet
                </label>
                <app-input
                    placeholder="Meet"
                    class="col-sm-9"
                    type="search-select"
                    :list="meetLists"
                    name="meet"
                    v-model="inputs.meet"
                    :isAnimatedDropdown="true"
                    required
                />
            </div> -->
    
            <!-- Meet -->
            <div class="form-group row align-items-center">
                <label for="inputs_course_meet" class="col-sm-3 mb-0">
                    Day
                </label>
                <app-input
                    placeholder="Day"
                    class="col-sm-9"
                    type="search-select"
                    :list="dayLists"
                    name="meet"
                    v-model="inputs.day"
                    :isAnimatedDropdown="true"
                    required
                />
            </div>
             
            <div class="form-group row align-items-center">
                <label for="inputs_time_start" class="col-sm-3 mb-0">
                    Time Start
                </label>
                <div class="col-sm-9">
                    <input
                    id="inputs_time_start"
                    class="form-control "
                    type="time"
                    :is-enable-minute="false"
                    v-model="inputs.time_start"
                    placeholder="Time Start || Example : 08:00"
                    />
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label for="inputs_time_end" class="col-sm-3 mb-0">
                    Time End
                </label>
                <div class="col-sm-9">
                    <input
                    id="inputs_time_end"
                    class="form-control "
                    type="time"
                    :is-enable-minute="false"
                    v-model="inputs.time_end"
                    placeholder="Time End || Example : 17:00"
                    />
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label for="inputs_course_date_clc_start" class="col-sm-3 mb-0">
                    CLC Start Date
                </label>
                <app-input
                    id="inputs_course_date_clc_start"
                    class="col-sm-9"
                    type="text"
                    v-model="inputs.course_date_clc_start"
                    :placeholder="'CLC Start Date || Example : W01'"
                    :required="true"
                />
            </div>
            <div class="form-group row align-items-center">
                <label for="inputs_course_date_clc_end" class="col-sm-3 mb-0">
                    CLC End Date
                </label>
                <app-input
                    id="inputs_course_date_clc_end"
                    class="col-sm-9"
                    type="text"
                    v-model="inputs.course_date_clc_end"
                    :placeholder="'CLC End Date || Example : W01'"
                    :required="true"
                />
            </div>
    
            <!-- Course Description -->
            <!-- <div class="form-group row align-items-center">
                <label for="inputs_course_description" class="col-sm-3 mb-0">
                    Class Description
                </label>
                <app-input
                    id="inputs_course_description"
                    class="col-sm-9"
                    type="textarea"
                    v-model="inputs.course_description"
                    :placeholder="'Class Description'"
                    :required="true"
                />
            </div> -->
    
            <div class="form-group row align-items-center">
                <label for="inputs_maximum_student" class="col-sm-3 mb-0">
                    Maximum Student
                </label>
                <app-input
                    id="inputs_maximum_student"
                    class="col-sm-9"
                    type="number"
                    v-model="inputs.maximum_student"
                    :placeholder="'Maximum Student'"
                    :required="true"
                />
            </div>
            <!-- Notes -->
            <div class="form-group row align-items-center">
                <label for="inputs_notes" class="col-sm-3 mb-0">
                    Notes
                </label>
                <app-input
                    id="inputs_notes"
                    class="col-sm-9"
                    type="textarea"
                    v-model="inputs.notes"
                    :placeholder="'Notes'"
                    :required="true"
                />
            </div>
    
            <div class="form-group row align-items-center">
                <label for="inputs_is_active" class="col-sm-3 mb-0">
                    &nbsp;
                </label>
                <div class="col-sm-8">
                    <app-input
                        id="inputs_is_active"
                        :list-value-field="$t('is_active')"
                        type="single-checkbox"
                        v-model="inputs.is_active"
                    />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";

export default {
	name: "NewCourseForm",
	mixins: [FormMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					is_active: "",
				};
			},
		},
        onAfterSubmit: {
            type: Function,
            default: (status, res) => console.log('onAfterSubmit = ' + status + ':', res),
        },
	},
	data() {
		return {
			preloader: false,
			inputs: {},
      		showCentre: false,
      		input_center_id: {},
     	 	input_teaching_type_id: {},
			input_academic_calendar_id : {},
      		input_teacher_id: {},
     	 	input_side_teacher_id: {},
			input_trainer_teacher_id : {},
			// input_product_level_id: this.value
			// 		? this.value.product_level
			// 		? {
			// 			product_level_id: this.value.product_level.product_level_id || 0,
			// 			product_level_code:
			// 				this.value.product_level.product_level_code || "",
			// 			product_level_desc:
			// 				this.value.product_level.product_level_desc || "",
			// 			}
			// 		: {
			// 			product_level_id: this.value.product_level?.product_level_id || 0,
			// 			product_level_code:
			// 				this.value.product_level?.product_level_code || "",
			// 			product_level_desc:
			// 				this.value.product_level?.product_level_desc || "",
			// 			}
			// 		: {
			// 			product_level_id: this.value.product_level.product_level_id || 0,
			// 			product_level_code:
			// 			this.value.product_level.product_level_code || "",
			// 			product_level_desc:
			// 			this.value.product_level.product_level_desc || "",
			// 		},
			// meetLists: [
        	// 			{ id: "1", value: "1" },
        	// 			{ id: "2", value: "2" },
        	// 			{ id: "3", value: "3" }
			// 		],
			dayLists: [
        				{ id: "1", value: "1" },
        				{ id: "2", value: "2" },
        				{ id: "3", value: "3" },
        				{ id: "4", value: "4" },
        				{ id: "5", value: "5" }
					],
                    
			teachingTypeList: [
        				{ id: "Offline", value: "Offline" },
        				{ id: "Online", value: "Online" },
					],
		};
	},
	created() {
		if (this.selectedUrl) {
			this.preloader = true;
		}
	},
    watch: {
        inputs(newVal) {
            this.$emit('input', newVal);
        },
    },
	methods: {
		submit() {
        	this.inputs.center_id = this.input_center_id.id;
            this.inputs.is_active = this.inputs.is_active ? 1 : 0;
			this.inputs.course_date_start = this.inputs.course_date_start ? this.formattedDate(this.inputs.course_date_start) : this.formattedDate(new Date())
			this.inputs.course_date_end = this.inputs.course_date_end ? this.formattedDate(this.inputs.course_date_end) : this.formattedDate(new Date().setMonth(new Date().getMonth() + 1))
			// this.inputs.course_date_clc_start = "CLCDEFAULTSTART1"
			// this.inputs.course_date_clc_end = "CLCDEFAULTEND1"
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
            this.onAfterSubmit?.(true, response);
		},
		afterError(response) {
			this.$toastr.s(response.data.message);
            this.onAfterSubmit?.(false, response);
		},
		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			if(response.data.time_start){
				this.inputs.time_start = response.data.time_start.slice(0,5);
			}
			if(response.data.time_end){
				this.inputs.time_end = response.data.time_end.slice(0,5);
			}
					
			let teachingType = {};

			if (response.data.teaching_type?.teaching_type_id) {
				this.inputs.teaching_type = response.data.teaching_type?.teaching_type_desc;
                    
                if(this.inputs.teaching_type == 'Offline'){
                    this.showCentre=true;
                }else{
                    this.showCentre=false;
                }
			}
			// this.setTeachingTypeId(teachingType);
			
			let academicCalendar = {};

			if (response.data.academic_calendar?.id) {
				academicCalendar = {
				id: response.data.academic_calendar?.id,
				academic_calendar_name: response.data.academic_calendar?.academic_calendar_name,
				};
			}

			this.setAcademicCalendarId(academicCalendar);
			
			let center = {};

			if (response.data.center?.id) {
				center = {
					id: response.data.center?.id,
					name: response.data.center?.name
				};
			}

			this.setCenterId(center);
			
			let teacher = {};

			if (response.data.teacher?.id) {
				teacher = {
					id: response.data.teacher?.id,
					full_name: response.data.teacher?.full_name
				};
			}

			this.setTeacherId(teacher);
			
			let sideTeacher = {};

			if (response.data.side_teacher?.id) {
				sideTeacher = {
					id: response.data.side_teacher?.id,
					full_name: response.data.side_teacher?.full_name
				};
			}

			this.setSideTeacherId(sideTeacher,true);
			
			let trainerTeacher = {};

			if (response.data.trainer_teacher?.id) {
				trainerTeacher = {
					id: response.data.trainer_teacher?.id,
					full_name: response.data.trainer_teacher?.full_name
				};
			}

			this.setTrainerTeacherId(trainerTeacher,true);
					
			// this.input_product_level_id = {
			// 	product_level_id: this.inputs.product_level?.product_level_id,
			// 	product_level_code: this.inputs.product_level?.product_level_code,
			// 	product_level_desc: this.inputs.product_level?.product_level_desc,
			// };

			this.preloader = false;
		},
		setCenterId(data) {
			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "center_id", data.id);
			}
			this.$set(this, "input_center_id", data);
		},
		// setProductLevelId(data) {
		// 	this.inputs.product_level_id = this.inputs.product_level_id;
		// 	if (data && data.hasOwnProperty("product_level_id")) {
		// 		this.inputs.product_level_id = data.product_level_id;
		// 	}
		// },
		setTeachingTypeId(data) {
			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "teaching_type_id", data.id);
			}

			this.$set(this, "input_teaching_type_id", data);
		},
        setTeachingType(data){
            if(data == 'Offline'){
                this.showCentre=true;
            }else{
                this.showCentre=false;
            }
            
        },
		setTeacherId(data) {
			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "teacher_id", data.id);
			}

			this.$set(this, "input_teacher_id", data);
		},
		setSideTeacherId(data, fromApi = false) {
			
			if (data && data.hasOwnProperty("id")) {
				if (!fromApi && this.inputs.side_teacher_id === data.id) {
					this.$set(this.inputs, "side_teacher_id", null);
					this.$set(this, "input_side_teacher_id", {});
				} else {
					this.$set(this.inputs, "side_teacher_id", data.id);
					this.$set(this, "input_side_teacher_id", data);
				}
			} else {
				this.$set(this.inputs, "side_teacher_id", null);
				this.$set(this, "input_side_teacher_id", {});
			}
		},
		setTrainerTeacherId(data, fromApi = false) {
			
			if (data && data.hasOwnProperty("id")) {
				if (!fromApi && this.inputs.trainer_teacher_id === data.id) {
					this.$set(this.inputs, "trainer_teacher_id", null);
					this.$set(this, "input_trainer_teacher_id", {});
				} else {
					this.$set(this.inputs, "trainer_teacher_id", data.id);
					this.$set(this, "input_trainer_teacher_id", data);
				}
			} else {
				this.$set(this.inputs, "trainer_teacher_id", null);
				this.$set(this, "input_trainer_teacher_id", {});
			}
		},
		setAcademicCalendarId(data) {
			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "academic_calendar_id", data.id);
			}

			this.$set(this, "input_academic_calendar_id", data);
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
};
</script>

